export default "__VITE_ASSET__QE4e598v__"